import dayjs from "dayjs";

export const migrations = {
  1: state => ({
    apiCache: {
      ...state.apiCache,
      quickFilters: ["RESPONDED"],
    },
  }),
  2: state => {
    delete state.apiCache.quickFilters;
    return state;
  },
};

export const leadMigrations = {
  0: state => ({
    lead: state.lead,
  }),
  1: state => ({
    lead: state.selectedLead,
  }),
};

export const reviewMigrations = {
  0: state => ({
    reviews: { ...state.reviews, filters: { ...state.reviews.filters, isAiGenerated: false } },
  }),
  // v1: default the Reviews date filter to "Month to date" (start of month →
  // today) for existing users whose persisted range predates this default.
  // Persisted state here is the reviews reducer state itself (`{ filters }`).
  1: state => ({
    ...state,
    filters: {
      ...state.filters,
      dateRange: {
        startDate: dayjs().startOf("month").toISOString(),
        endDate: dayjs().endOf("day").toISOString(),
      },
    },
  }),
};
